import React, { useState } from "react";
import Badge1 from "./image/badge(1).png"

import "./about.css"
import Badge from "./image/badge.png";
import EU from "./image/erusmus.png";
import { Container, Row, Col } from "react-bootstrap";
import Resume from "./resume";
import MIST from "./image/MIST.png";
import DCC from "./image/DCC.png";
import AK from "./image/AKK.png";
import Cap from "./image/cap.png"
import IFROS from "./image/IFROS.png"

export default function Academic() {
    
       
        return (
    
            <div style={{marginTop:50, color:"white", fontSize:25, fontFamily:"serif", height:2500}}>
                <Container>
                <Row style={{fontSize: 20}}>
                            <Col xs={3} lg={2} md={2}>

<p> 2025</p>

                            </Col>
                         
                            <Col xs={9} lg={10} md={10}>
                                <h style={{color:"#d4ce31"}}>Masters Thesis Intern</h>
                                <br/>
                                <h>HUN-REN SZTAKI (Institute for Computer Science and Control)</h>
                                <br/>
                                <h style={{fontSize: 20}}> <i>Budapest,Hungary</i> </h>
                                <br/>
                                <h  style={{ color: "#bcc4b7" }}><u>Skills</u></h><br/>
                                <h>  ✓ Explored how curriculum learning improves the efficiency and performance of Deep Reinforcement Learning agents in Robotics task by designing and testing fixed and adaptive strategies.
</h>



                                

</Col> 
                      
</Row>
<br/>
<br/>

                      
                       
                        <Row style={{fontSize: 20}}>
                            <Col xs={3} lg={2} md={2}>

<p> 2024 </p>

                            </Col>
                         
                         <br/>
<br/>
                            <Col xs={9} lg={10} md={10}>
                                <h style={{color:"#d4ce31"}}>Summer Intern</h>
                                <br/>
                                <h>VICOROB</h>
                                <br/>
                                <h style={{fontSize: 20}}> <i>Girona, Spain</i> </h>
                                <br/>
                                <h  style={{ color: "#bcc4b7" }}><u>Skills</u></h><br/>
                                <h>  ✓ Worked in a team to implement a Deep Learning based model using ResNet50 with PyTorch to classify Melanoma and Benign and develop a Vision Transformer based model using TensorFlow for Melanoma detection.
</h>



                                

</Col> 
                        </Row>
                       
                        <br/>
<br/>
<Row style={{fontSize: 20}}>
                            <Col xs={3} lg={2} md={2}>

<p> 2021-2022</p>

                            </Col>
                         
                            <Col xs={9} lg={10} md={10}>
                                <h style={{color:"#d4ce31"}}>Research Engineer</h>
                                <br/>
                                <h>Visual Information Processing (VIP), <i>MIST</i></h>
                                <br/>
                             
                                <h  style={{ color: "#bcc4b7" }}><u>Projects</u></h><br/>
                               <li><h>  Violence Detection Module.
</h></li> 
<li><h>Film Censorship and Rating Module.</h></li>
<li><h>Sign Language Translation Module.</h></li>



                                

</Col> 
</Row>
<br/>
<br/>
                        <Row style={{fontSize: 20}}>
                            <Col xs={3} lg={2} md={2}>

<p> 2021 </p>

                            </Col>
                         
                            <Col xs={9} lg={10} md={10}>
                                <h style={{color:"#d4ce31"}}>Industrial Trainee</h>
                                <br/>
                                <h>Teletalk Bangladesh Ltd.</h>
                                <br/>
                                <h style={{fontSize: 20}}> <i>Gulshan, Dhaka,Bangladesh</i> </h>
                                <br/>
                                <h  style={{ color: "#bcc4b7" }}><u>Skills</u></h><br/>
                                <h> ✓ Learned about 1G, 2G, 3G, 4G Technology, and their communication process. 
</h><br/>
<h> ✓ Exploring the existing technologies of the telecommunication field.</h>


                                

</Col> 
                        </Row>
                        <br/>
<br/>
                        <Row style={{fontSize: 20}}>
                            <Col xs={3} lg={2} md={2}>
                            <p> 2021 </p>
                            </Col>
                            <Col xs={9} lg={10} md={10}>
                            <h style={{color:"#d4ce31"}}>Industrial Trainee</h>
                                <br/>
                                <h>Energypac Electronics Ltd.
Factory</h><br/>
<h style={{fontSize: 20}}> <i>Gazipur,Bangladesh</i> </h>
                                <br/>
                                <h  style={{ color: "#bcc4b7" }}><u>Skills</u></h><br/>
                                <h> ✓ Learned about the Light, and Fan making process.
 
</h><br/>
<h> ✓ Learned about Sales management.</h>


</Col>
                        </Row>
                        <br/>
<br/>
                        <Row style={{fontSize: 20}}>
                            <Col xs={3} lg={2} md={2}>
                            <p> 2021 </p>    
                            </Col>
                            <Col xs={9} lg={10} md={10}>
                            <h style={{color:"#d4ce31"}}>Industrial Trainee</h>
                                <br/>
                                <h>Dhaka Electric Supply
Company Limited (DESCO)</h><br/>
<h style={{fontSize: 20}}> <i>Mirpur, Dhaka, Bangladesh</i> </h>
                                <br/>
                                <h  style={{ color: "#bcc4b7" }}><u>Skills</u></h><br/>
                                <h> ✓Learned about  Electrical Power Distribution.
 
</h><br/>
<h> ✓ Learned the necessary skills and technical information of the power field by exploring different factories.</h>

</Col>

                        </Row>
                        <div>

                        </div>
</Container>
                    </div>
                 
        )
    }